.combobox {
  position: relative;
  min-inline-size: 0;
}

.input {
  inline-size: 100%;
  block-size: var(--control-height);
  padding: 0 10px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background: var(--surface-raised);
  color: var(--text);
  font-size: var(--font-size-13);
}

/* Same indicator as `Input` (decision D-UX-5). */
.input:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: -1px;
  box-shadow: 0 0 0 3px var(--action-soft);
}

.popup {
  position: absolute;
  z-index: var(--z-popover);
  inset-inline: 0;
  inset-block-start: calc(100% + 4px);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--surface-raised);
  box-shadow: var(--shadow-popover);
  overflow: hidden;
}

/* The mockup's `.pk-list` and `.pk-opt`. */
.listbox {
  max-block-size: 320px;
  margin: 0;
  padding: var(--space-1);
  overflow: auto;
  list-style: none;
}

.listbox:empty {
  display: none;
}

.option {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2);
  border-radius: var(--radius-control);
  font-size: var(--font-size-13);
  cursor: pointer;
}

.option:hover,
.option[aria-selected="true"] {
  background: var(--state-active);
}

.optionLabel {
  flex: 1;
  min-inline-size: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.description {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-variant-numeric: tabular-nums;
}

.status:empty {
  display: none;
}

/* The empty result, drawn where the list would be. */
.status {
  position: absolute;
  z-index: var(--z-popover);
  inset-inline: 0;
  inset-block-start: calc(100% + 4px);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--surface-raised);
  box-shadow: var(--shadow-popover);
  padding: var(--space-4);
  color: var(--text-muted);
  font-size: var(--font-size-13);
  text-align: center;
}
